(function () {

    'use strict';

    angular.module('Services').service('AccountingCustomerBillingTableService', AccountingCustomerBillingTableService);

    AccountingCustomerBillingTableService.$inject = [
        'AccountingService',
        'TableLiteFactory',
        'toastr',
        '$filter',
        'ConfirmationModalFactory',
        '$uibModal'
    ];

    function AccountingCustomerBillingTableService(
        AccountingService,
        TableLiteFactory,
        toastr,
        $filter,
        ConfirmationModalFactory,
        $uibModal
    ) {
        return function (defaultParams = {}) {
            const closeBillingConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.closeBilling.MESSAGE',
                code: 'messages.warning.closeBilling.CODE'
            });

            const tableData = {
                tableName: 'AccountingCustomerBillingTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Customer',
                        viewName: 'customerName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Amount Ex Tax',
                        viewName: 'amount'
                    },
                    {
                        label: 'Tax',
                        viewName: 'amountTax'

                    },
                    {
                        label: 'Bill & Email Customer',
                        viewName: 'action',
                        class: 'text-center',
                        filter: {
                            type: 'button'
                        }
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.CustomerBilling.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: angular.extend({
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }, defaultParams.filters || {})
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row) {
                    row.customerName = row.customer && row.customer.name || 'N/A';
                    row.amount = $filter('bbaCurrency')(row.amountExTax)
                    row.href = '/accounting/customer-billing/' + row.id;
                    row.action = {
                        type: 'button',
                        buttons: [
                            {
                                text: 'PDF',
                                class: 'btn-primary',
                                action: (data) => {
                                    downloadFile(data, 'application/pdf');
                                }
                            },
                            {
                                text: 'CSV',
                                class: 'btn-primary',
                                action: (data) => {
                                    downloadFile(data, 'text/csv');
                                }
                            },
                            {
                                text: 'CLOSE',
                                class: 'btn-primary',
                                action: (data) => {
                                    closeBilling(data);
                                }
                            },
                            {
                                text: 'EMAIL',
                                class: 'btn-primary',
                                action: (data) => {
                                    emailBilling(data);
                                }
                            }
                        ]
                    };
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;

            function downloadFile(data, fileType) {
                const payload = {
                    customerId: data.id,
                    fileType: fileType
                };
                AccountingService.CustomerBilling.downloadFile(function (result) {
                }, function (error) {
                    toastr.error(error.message || 'Try again', 'Unable to download file');
                }, payload);
            }

            function closeBilling(data) {
                closeBillingConfirmation.getInstance().result.then(cond => {
                    if (cond) {
                        data.action.buttons[2].text = "Processing...";
                        processCloseBilling(data.id, null, false);
                    }
                });
            }

            function emailBilling(data) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/accounting/modals/email-billing-modal.html',
                    controller: 'EmailBillingModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body')
                });

                modalInstance.result.then((fileType) => {
                    if (!fileType) { return; } 
                    data.action.buttons[3].text = "Processing...";
                    processCloseBilling(data.id, fileType.value, true);
                });
            }

            function processCloseBilling(id, fileTypes = null, sendEmail) {
                AccountingService.CustomerBilling.closeBilling(success => {
                    toastr.success('Billing closed', 'Success');
                    sendRequest();
                }, error => {
                    toastr.error(error.error.message, 'Error');
                }, id, fileTypes, sendEmail);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/AccountingCustomerBillingTableService.js